import { Grid } from "@mui/material";
import React from "react";
import PostsHeader from "./home/header";
import PostsTable from "./home/table";

const Posts = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PostsHeader />
      </Grid>
      <Grid item xs={12}>
        <PostsTable />
      </Grid>
    </Grid>
  );
};

export default Posts;
